import { render, staticRenderFns } from "./VuetableFieldYCheckbox.vue?vue&type=template&id=7aa32ab8"
import script from "./VuetableFieldYCheckbox.vue?vue&type=script&lang=js"
export * from "./VuetableFieldYCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports